import { POST_ENTERPRISES_ERROR, POST_ENTERPRISES_START, POST_ENTERPRISES_SUCCESS } from '../../types';

export default function post_enterprises(state, action) {
  switch (action.type) {
    case POST_ENTERPRISES_START:
      return { ...state };
    case POST_ENTERPRISES_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_ENTERPRISES_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}